import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./AuthForms.css"; // Import the CSS file


const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const { data } = await axios.post("https://payweek.com/api/forgot-password", { email });

            //const { data } = await axios.post("http://localhost:5000/forgot-password", { email });
            setMessage(data.message);
            navigate("/resetpassword");
        } catch (err) {
            console.error(err);
            setMessage(err.response?.data || "Error processing request.");
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-card">
                <h2>Forgot Password</h2>
                {message && <p className={`auth-message ${message.includes("Error") ? "auth-error" : "auth-success"}`}>{message}</p>}
                <form onSubmit={handleSubmit} className="auth-form">
                    <input
                        type="email"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        className="auth-input"
                    />
                    <button type="submit" className="auth-button">Send OTP</button>
                </form>
            </div>
        </div>
    );
};

export default ForgotPassword;




// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";

// const ForgotPassword = () => {
//     const [email, setEmail] = useState("");
//     const [message, setMessage] = useState("");
//     const navigate = useNavigate();

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             // Await the axios post call
//             const { data } = await axios.post("http://localhost:5000/forgot-password", { email });
//             setMessage(data.message); // Use the message from the response
//             navigate("/resetpassword"); // Navigate to reset password page
//         } catch (err) {
//             console.error(err);
//             setMessage(err.response?.data || "Error processing request.");
//         }
//     };

//     return (
//         <div className="forgot-password">
//             <h2>Forgot Password</h2>
//             {message && <p>{message}</p>}
//             <form onSubmit={handleSubmit}>
//                 <input
//                     type="email"
//                     placeholder="Enter your email"
//                     value={email}
//                     onChange={(e) => setEmail(e.target.value)}
//                     required
//                 />
//                 <button type="submit">Send OTP</button>
//             </form>
//         </div>
//     );
// };

// export default ForgotPassword;
